import Signin from "./pages/signin"
import NotFound from "../shares/components2/not-found.vue";

export default [
    {
        path: "*",
        component: NotFound
        },
        
    {
        path: "/login",
        component: Signin,
        name: 'login',
        meta: {
            guest: true,
        },
        beforeEnter() { location.href = process.env.VUE_APP_UHIVE_MAIN_SITE + "web/login/" }
    }
]